const OUTCOMES = ["open", "abandoned", "overridden", "cleared", "replaced"];
const when = (iso) => (iso ? new Date(iso).toLocaleString() : "");

// The block log next to the held ducks: per-outcome counts as filters + the newest rows (fingerprints, never images).
export const BlockLogList = ({ log, outcome, onOutcome, abandonDays }) => (
  <section data-testid="block-log" className="rounded-3xl border border-border bg-card/60 p-4 sm:p-5 space-y-3">
    <div>
      <p className="font-heading font-bold text-base md:text-lg">Block log</p>
      <p className="text-xs text-muted-foreground">Every block the check raised, so false positives can be checked. Abandoned = still open after {abandonDays} days, or the duck was archived.</p>
    </div>
    <div className="flex flex-wrap gap-2">
      <button type="button" data-testid="block-log-filter-all" onClick={() => onOutcome(null)} className={`rounded-full px-3 py-1 text-xs border ${!outcome ? "bg-foreground text-background" : "border-border"}`}>
        all
      </button>
      {OUTCOMES.map((o) => (
        <button key={o} type="button" data-testid={`block-log-filter-${o}`} onClick={() => onOutcome(o)} className={`rounded-full px-3 py-1 text-xs border ${outcome === o ? "bg-foreground text-background" : "border-border"}`}>
          {o} · {log?.counts?.[o] ?? 0}
        </button>
      ))}
    </div>
    {log?.rows?.length ? (
      <ul className="divide-y divide-border text-xs">
        {log.rows.map((r) => (
          <li key={r.id} data-testid="block-log-row" className="py-2 grid grid-cols-[auto_1fr_auto] gap-3 items-center">
            <span className="font-mono2 text-muted-foreground">{when(r.at)}</span>
            <span className="min-w-0 truncate">
              <span className="font-semibold">{r.view}</span> · {r.code} · duck {String(r.creation_id || "").slice(0, 8)} · {r.stage}
            </span>
            <span className="rounded-full bg-muted px-2 py-0.5">{r.outcome}</span>
          </li>
        ))}
      </ul>
    ) : (
      <p data-testid="block-log-empty" className="text-sm text-muted-foreground">Nothing logged{outcome ? ` as ${outcome}` : ""}.</p>
    )}
  </section>
);
